import { render, staticRenderFns } from "./splitSystem.vue?vue&type=template&id=05fb5c7c&scoped=true&"
import script from "./splitSystem.vue?vue&type=script&lang=js&"
export * from "./splitSystem.vue?vue&type=script&lang=js&"
import style0 from "./splitSystem.vue?vue&type=style&index=0&id=05fb5c7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fb5c7c",
  null
  
)

export default component.exports